import { IPurchaseRequestor } from "../../types/purchaseRequestor.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

const API_URL = import.meta.env.VITE_API_URL;

const makeRequestDebounced = createDebounce(makeRequest, 200);

type GetPurchaseRequestorsOptions = {
  status?: string[];
  search?: string;
  page?: number;
  itemsPerPage?: string;
  orderBy?: string;
  fields?: string;
};

export async function getPurchaseRequestors(
  options: GetPurchaseRequestorsOptions = {}
) {
  const {
    status = [],
    search = "",
    page = 1,
    itemsPerPage = "10",
    orderBy = "updatedAt",
    fields = "name, companyId",
  } = options;
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
  });
  let statusParam = "";
  if (Array.isArray(status) && status.length > 0) {
    statusParam = status.join(",");
  } else if (typeof status === "string") {
    statusParam = status;
  }
  status && params.append("filters[status]", statusParam);
  search && params.append("search", search);
  orderBy && params.append("orderBy", orderBy);

  const url = `${API_URL}/purchase-requestor?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    IPurchaseRequestor[]
  > & { totalItems: number };

  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
}

export async function getPurchaseRequestorById(id: string) {
  const url = `${API_URL}/purchase-requestor/${id}`;
  return (await makeRequestDebounced(
    url
  )) as ApiResponseType<IPurchaseRequestor>;
}

export async function getAllPurchaseRequestors() {
  const url = `${API_URL}/purchase-requestor-all`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    IPurchaseRequestor[]
  >;

  return { ok: result.ok, data: result.data };
}

export async function createPurchaseRequestor(data) {
  const url = `${API_URL}/purchase-requestor`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  const result = makeRequestDebounced(url, options) as Promise<
    ApiResponseType<IPurchaseRequestor>
  >;

  return result;
}

export async function updatePurchaseRequestor(data: IPurchaseRequestor) {
  const url = `${API_URL}/purchase-requestor`;
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  const result = makeRequestDebounced(url, options) as Promise<
    ApiResponseType<IPurchaseRequestor>
  >;
  return result;
}
